(function () {
  const section = document.getElementById('skin-guide');
  if (!section) return;

  const tabs = section.querySelectorAll('[data-skin-guide-tab]');
  const panels = section.querySelectorAll('[data-skin-guide-panel]');
  const resultAnchor = section.querySelector('#skin-guide-result');
  const form = section.querySelector('.skin-guide-ask-form');
  const input = section.querySelector('[data-skin-guide-input]');

  function scrollToResult() {
    if (!resultAnchor || !window.matchMedia('(max-width: 768px)').matches) return;

    const nav = document.querySelector('.nav');
    const navHeight = nav ? nav.offsetHeight : 72;
    const top =
      resultAnchor.getBoundingClientRect().top + window.scrollY - navHeight - 12;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function activateTab(tab, options) {
    const scrollResult = options && options.scrollResult;
    const id = tab.getAttribute('data-skin-guide-tab');
    tabs.forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panels.forEach((panel) => {
      const active = panel.getAttribute('data-skin-guide-panel') === id;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    if (scrollResult) {
      scrollToResult();
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activateTab(tab, { scrollResult: true }));
    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const list = Array.from(tabs);
      const index = list.indexOf(tab);
      const nextIndex =
        event.key === 'ArrowRight'
          ? (index + 1) % list.length
          : (index - 1 + list.length) % list.length;
      list[nextIndex].focus();
      activateTab(list[nextIndex], { scrollResult: true });
    });
  });

  const SUPPORT_EMAIL = 'customersupport@disuribeauty.com';

  const finI18nEl = document.getElementById('skin-guide-fin-i18n');
  let finI18n = {};
  if (finI18nEl) {
    try {
      finI18n = JSON.parse(finI18nEl.textContent);
    } catch (err) {
      console.error('Skin guide i18n JSON invalid', err);
    }
  }

  function getActiveConcernCard() {
    return section.querySelector('.skin-guide-concern-card.is-active');
  }

  function getActiveConcernLabel() {
    const concern = getActiveConcernCard();
    return concern
      ? concern.querySelector('.skin-guide-concern-card__label')?.textContent.trim() || ''
      : '';
  }

  function getActiveFinContext() {
    const concern = getActiveConcernCard();
    if (!concern) return null;

    const product = concern.getAttribute('data-fin-product');
    const ppm = concern.getAttribute('data-fin-ppm');
    const handle = concern.getAttribute('data-fin-handle');

    if (!product && !ppm && !handle) return null;

    return { product: product || '', ppm: ppm || '', handle: handle || '' };
  }

  function buildGuidanceMessage(question) {
    const concernLabel = getActiveConcernLabel();
    const match = getActiveFinContext();
    const lines = [];

    if (concernLabel.length > 0) {
      lines.push(`${finI18n.concernPrefix || 'Skin concern:'} ${concernLabel}`);
    } else {
      lines.push(finI18n.questionHeading || 'My skin question:');
    }

    lines.push('');
    lines.push(`${finI18n.questionLabel || 'My question:'}\n${question}`);
    lines.push('');
    lines.push(
      finI18n.answerInstruction ||
        'Please answer in this chat now with a specific DISURI product recommendation (name, key ppm, and simple how-to use). Do not tell me to wait for email or that the team will reply later.'
    );

    if (match && (match.product || match.ppm || match.handle)) {
      lines.push('');
      const ritualLine = [
        finI18n.ritualMatch || 'Homepage ritual match:',
        match.product,
        match.ppm ? `— ${match.ppm}` : '',
      ]
        .filter(Boolean)
        .join(' ');
      lines.push(
        match.handle
          ? `${ritualLine}. https://disuribeauty.com/products/${match.handle}`
          : ritualLine
      );
    }

    return lines.join('\n');
  }

  function showFinFallback(fallbackEl, visible) {
    if (!fallbackEl) return;
    fallbackEl.hidden = !visible;
  }

  function openIntercomGuidance(prefill) {
    if (typeof window.Intercom === 'function') {
      window.Intercom('showNewMessage', prefill);
      return true;
    }
    return false;
  }

  function openMailtoFallback(prefill) {
    const subject = encodeURIComponent(
      finI18n.mailtoSubject || 'Skin guide question — DISURI Beauty'
    );
    const body = encodeURIComponent(prefill);
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  }

  if (form && input) {
    const useFin = form.getAttribute('data-use-fin') !== 'false';
    const fallbackEl = section.querySelector('[data-skin-guide-fin-fallback]');

    form.addEventListener('submit', (event) => {
      const question = input.value.trim();
      if (!question) {
        event.preventDefault();
        input.focus();
        return;
      }

      const prefill = buildGuidanceMessage(question);

      if (!useFin) {
        event.preventDefault();
        input.value = prefill;
        const action = form.getAttribute('action') || '/pages/contact';
        const url = new URL(action, window.location.origin);
        url.searchParams.set('body', prefill);
        window.location.href = url.toString();
        return;
      }

      event.preventDefault();
      showFinFallback(fallbackEl, false);

      if (openIntercomGuidance(prefill)) {
        return;
      }

      showFinFallback(fallbackEl, true);
      openMailtoFallback(prefill);
    });
  }

  function syncBundleHeroes(cart, options) {
    if (!cart || !Array.isArray(cart.items)) return;

    const scrollAdded = Boolean(options && options.scrollAdded);

    section.querySelectorAll('[data-bundle-hero]').forEach((hero) => {
      const variantId = hero.getAttribute('data-variant-id');
      if (!variantId) return;

      const wasInCart = hero.classList.contains('is-in-cart');
      const inCart = cart.items.some(
        (item) => String(item.variant_id) === String(variantId)
      );

      hero.classList.toggle('is-in-cart', inCart);

      if (inCart && !wasInCart && scrollAdded) {
        const addedBlock = hero.querySelector('[data-bundle-added]');
        if (addedBlock) {
          window.requestAnimationFrame(() => {
            addedBlock.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          });
        }
      }
    });
  }

  function fetchCartAndSync(options) {
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return fetch(`${root}cart.js`)
      .then((res) => res.json())
      .then((cart) => {
        syncBundleHeroes(cart, options);
        return cart;
      })
      .catch(() => {});
  }

  document.addEventListener('cart:updated', (event) => {
    syncBundleHeroes(event.detail, { scrollAdded: true });
  });

  fetchCartAndSync();

  const stickyBar = section.querySelector('[data-skin-guide-sticky]');
  const stickyCta = section.querySelector('[data-skin-guide-sticky-cta]');
  const mobileMq = window.matchMedia('(max-width: 768px)');

  function getActiveBundleHero() {
    const panel = section.querySelector('.skin-guide-panel.is-active');
    return panel ? panel.querySelector('[data-bundle-hero]') : null;
  }

  function syncStickyFromHero() {
    if (!stickyBar || !stickyCta) return;

    const hero = getActiveBundleHero();
    if (!hero || hero.classList.contains('is-in-cart')) {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      stickyCta.hidden = true;
      return;
    }

    const sourceBtn = hero.querySelector('[data-bundle-commerce] [data-quick-add]');
    const sourceLink = hero.querySelector('[data-bundle-commerce] .skin-guide-bundle-hero__cta[href]');

    if (sourceBtn && sourceBtn.dataset.variantId) {
      stickyCta.hidden = false;
      stickyCta.textContent = sourceBtn.textContent.trim();
      stickyCta.dataset.variantId = sourceBtn.dataset.variantId;
      stickyCta.disabled = sourceBtn.disabled || sourceBtn.classList.contains('is-loading');
      stickyCta.onclick = null;
      return;
    }

    if (sourceLink && sourceLink.getAttribute('href')) {
      stickyCta.hidden = false;
      stickyCta.textContent = sourceLink.textContent.trim();
      delete stickyCta.dataset.variantId;
      stickyCta.disabled = false;
      stickyCta.onclick = () => {
        window.location.href = sourceLink.href;
      };
      return;
    }

    stickyCta.hidden = true;
  }

  function updateStickyVisibility() {
    if (!stickyBar || !stickyCta || stickyCta.hidden) {
      if (stickyBar) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (!mobileMq.matches) {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      return;
    }

    const hero = getActiveBundleHero();
    if (!hero) {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      return;
    }

    const nav = document.querySelector('.nav');
    const navHeight = nav ? nav.offsetHeight : 72;
    const rect = hero.getBoundingClientRect();
    const heroPastViewport = rect.bottom < navHeight + 8;
    const show = heroPastViewport;

    stickyBar.classList.toggle('is-visible', show);
    stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function refreshSticky() {
    syncStickyFromHero();
    updateStickyVisibility();
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      window.requestAnimationFrame(refreshSticky);
    });
  });

  if (stickyCta) {
    stickyCta.addEventListener('click', (event) => {
      if (!stickyCta.dataset.variantId && stickyCta.onclick) {
        event.preventDefault();
      }
    });
  }

  window.addEventListener(
    'scroll',
    () => {
      window.requestAnimationFrame(updateStickyVisibility);
    },
    { passive: true }
  );

  mobileMq.addEventListener('change', refreshSticky);
  document.addEventListener('cart:updated', refreshSticky);
  refreshSticky();
})();
